














































import { Component, Vue } from 'vue-property-decorator';
import { Forecast } from '../models/Forecast';
import axios from 'axios';

@Component({})
export default class FetchDataView extends Vue {
  private loading: boolean = true;
  private showError: boolean = false;
  private errorMessage: string = 'Error while loading weather forecast.';
  private forecasts: Forecast[] = [];
  private headers = [
    { text: 'Date', value: 'dateFormatted' },
    { text: 'Temp. (C)', value: 'temperatureC' },
    { text: 'Temp. (F)', value: 'temperatureF' },
    { text: 'Summary', value: 'summary' },
  ];

  private created() {
    this.fetchWeatherForecasts();
  }

  private fetchWeatherForecasts() {
    axios
      .get<Forecast[]>('api/SampleData/WeatherForecasts')
      .then((response) => {
        this.forecasts = response.data;
      })
      .catch((e) => {
        this.showError = true;
        this.errorMessage = `Error while loading weather forecast: ${e.message}.`;
      })
      .finally(() => (this.loading = false));
  }
}
